"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = (0, _styledSystem.style)({
  prop: 'WebkitBackgroundClip'
});
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzdHlsZSIsInByb3AiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY3VzdG9tUHJvcHMvd2Via2l0QmFja2dyb3VuZENsaXAudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgc3R5bGUgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcblxuZXhwb3J0IGRlZmF1bHQgc3R5bGUoeyBwcm9wOiAnV2Via2l0QmFja2dyb3VuZENsaXAnIH0pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTtBQUFzQyxlQUV2QixJQUFBQSxtQkFBSyxFQUFDO0VBQUVDLElBQUksRUFBRTtBQUF1QixDQUFDLENBQUM7QUFBQSJ9